import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';

export const pricingPlansApi = createApi({
  reducerPath: 'pricingPlansQueries',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['PricingPlans', 'PricingPlan'],
  endpoints: (builder) => ({
    getPricingPlans: builder.query({
      query: (filter = { page: 1, limit: 10 }) => ({
        url: `pricing-plans/`,
        method: 'GET',
        params: filter,
      }),
      providesTags: ['PricingPlans'],
    }),
    getRawPricingPlans: builder.query({
      query: (filter = { page: 1, limit: 20 }) => ({
        url: `pricing-plans/`,
        method: 'GET',
        params: { ...filter, raw: true },
      }),
      providesTags: ['PricingPlans'],
    }),
    getPricingPlanById: builder.query({
      query: (id) => ({
        url: `pricing-plans/${id}`,
        method: 'GET',
      }),
      providesTags: ['PricingPlan'],
    }),
    updatePlanFeatures: builder.mutation({
      query: ({ id, features }) => ({
        url: `pricing-plans/${id}/features`,
        method: 'PATCH',
        body: { features },
      }),
      invalidatesTags: ['PricingPlans'],
    }),
    updatePlanTitle: builder.mutation({
      query: ({ id, title }) => ({
        url: `pricing-plans/${id}/title`,
        method: 'PATCH',
        body: { title },
      }),
      invalidatesTags: ['PricingPlans'],
    }),
    setPlanArchived: builder.mutation({
      query: ({ id, isArchived }) => ({
        url: `pricing-plans/${id}/archive`,
        method: 'PATCH',
        body: { isArchived },
      }),
      invalidatesTags: ['PricingPlans'],
    }),
    updatePlanDescription: builder.mutation({
      query: ({ id, description }) => ({
        url: `pricing-plans/${id}/description`,
        method: 'PATCH',
        body: { description },
      }),
      invalidatesTags: ['PricingPlans'],
    }),
    updatePlanPricing: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `pricing-plans/${id}/pricing`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['PricingPlans'],
    }),
  }),
});

export const {
  useGetPricingPlansQuery,
  useGetRawPricingPlansQuery,
  useGetPricingPlanByIdQuery,
  useUpdatePlanFeaturesMutation,
  useUpdatePlanDescriptionMutation,
  useUpdatePlanTitleMutation,
  useSetPlanArchivedMutation,
  useUpdatePlanPricingMutation,
} = pricingPlansApi;
